export function FacebookAdIdViewConstructor(services, callbacks, context, siteTypeConfig) {
  
  let joint = services.joint;

  return joint.shapes.html.AbstractElementView.extend({

    isElementEditable: false,

    angularTemplate: `
<div layout="row">
  <span translate-once="parameters/quick_replies/details/graph/edit_ad_id_field_label"></span>: 
  <span> {{ elementData.adId }} </span>
</div>
`,

  });
}
